import { getRectangleVertices, getPointsVertices } from './helperFunctions'
import { useImageReviewStore } from 'Store/pages/imageReview/imageReviewStore'
import { useMarkerStore } from 'Store/pages/imageReview/markerStore'
import { useMeasurementStore } from 'Store/pages/imageReview/measurementsStore'
import { MarkerTypes } from 'Modules/types/pages/imageReview/enums'

function handleAnnotationCreated(markerEvent) {
  const reviewStore = useImageReviewStore()
  const markerStore = useMarkerStore()
  const { createTempAnnotation } = reviewStore.annotationsStore
  const { createMarkerEntry } = markerStore

  const marker = markerEvent.marker
  let bounds

  if (marker.typeName === MarkerTypes.Rectangle) {
    bounds = getRectangleVertices(
      marker.state.position.x,
      marker.state.position.y,
      marker.state.dimensions.width,
      marker.state.dimensions.height
    )
  }
  if (marker.typeName === MarkerTypes.Polygon) {
    bounds = getPointsVertices(marker.state.points)
  }

  const tempId = createTempAnnotation(bounds)
  marker.state.meta = {
    ...marker.state.meta,
    id: tempId,
  }
  createMarkerEntry(tempId, marker)
  marker.controller.selectMarker()
  marker.state.isSelectionLocked = true
}

function handleAnnotationSelected(markerEvent) {
  const markerStore = useMarkerStore()
  const measurementStore = useMeasurementStore()

  //Only allow one discrepancy annotation to be selected while measurement is selected.
  if (measurementStore.currentMeasurement && markerStore.selectedMarkers.length === 1) {
    markerEvent.marker.controller.deselectMarker()
    return
  }
  markerStore.addSelectedMarker(markerEvent.marker)
}

function handleAnnotationDeselected(markerEvent) {
  const markerStore = useMarkerStore()
  markerStore.removeSelectedMarker(markerEvent.marker)
  markerStore.removeHoveredMarker(markerEvent.marker)
}

function handleAnnotationMouseEnter(markerEvent) {
  const markerStore = useMarkerStore()
  markerStore.addHoveredMarker(markerEvent.marker)
}

function handleAnnotationMouseLeave(markerEvent) {
  const markerStore = useMarkerStore()
  markerStore.removeHoveredMarker(markerEvent.marker)
}

function handleAnnotationEdit(markerEvent) {
  const markerStore = useMarkerStore()
  markerStore.addBoundUpdatedMarker(markerEvent.marker)
}

export {
  handleAnnotationCreated,
  handleAnnotationSelected,
  handleAnnotationDeselected,
  handleAnnotationMouseEnter,
  handleAnnotationMouseLeave,
  handleAnnotationEdit,
}
